<template>
  <div class="advantage-card">
      <div class="advantage-why">
        <h3 class="why-title-h3">代理记账为什么选中税</h3>
        <div class="why-content">
          <div class="why-content-title">
            <div class="why-title-img">
              <img src="../components/home/images/组 2829.png" alt />
            </div>
            <div class="ind">
              <h4>中税财务公司</h4>
              <h4 class="ind-two">低价服务公司</h4>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>会计均持证上岗，高学历高职称，注册会计师、税务师质量把关</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2523.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>会计人员良莠不齐</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>客户能微信实时查询财务报表数据；智慧做账报税，准确、高效</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2524.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>客户不能实时看账，不够透明，做账报税效率较低</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>每周培训，实时跟进最新政策，及时享税收优惠政策</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2525.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>知识更新不及时，没有注会等专业人才</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>三人团队（管理人员、沟通会计、记账会计）服务一家客户，流程规范、严谨</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2830.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>没有规范统一的执业标准，比较散乱</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>能提供税务风险测算，无缝对接中税会计/税务师，满足审计、税收合规安排等高端需求</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2831.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>缺乏税务风险意识，业务能力单一</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>标准化合同，严格遵循商业保密原则</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2832.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>客户的个人及企业信息可能被倒卖</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>银行开户全程代办，公司银行专员一对一指导网银及快捷支付</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2833.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>没有相关的银企对接</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
          <div class="why-content-one no-border-why">
            <div class="one-cont">
              <div class="one-img1">
                <img src="../components/home/images/路径 2231.png" alt />
              </div>
              <div class="one-text">
                <p>收费合理、透明，代账费包含工商年报和税务年报</p>
              </div>
            </div>
            <div class="one-img2">
              <img src="../components/home/images/组 2834.png" alt />
            </div>
            <div class="one-cont one-cont-right">
              <div class="cont-right-text">
                <p>以低价揽客，但是后续收费项目繁多</p>
              </div>
              <div class="one-img3">
                <img src="../components/home/images/路径 2239.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'bookkeeping',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.advantage-card {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  .advantage-why {
    position: relative;
    width: 100%;
    border-radius: 10px;
    // padding: 0 50px;
    box-sizing: border-box;
    background: #fff;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    .why-title-h3 {
      margin-top: 40px;
      font-size: 30px;
    }
    .why-content {
      width: 100%;
      .why-content-title {
        position: relative;
        margin-top: 30px;
        .why-title-img {
          position: relative;
          top: 0;
          z-index: -10;
          img {
            width: 100%;
          }
        }
        .ind {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-size: 18px;
            color: #fff;
          }
          .ind-two {
            color: black;
          }
        }
      }
      .why-content-one {
        display: flex;
        justify-content: space-between;
        padding: 11px;
        border-bottom: 1px dashed #ccc;
        .one-cont {
          display: flex;
          align-items: center;
          flex: 3;
          .one-img1 {
            width: 20px;
            padding-right: 5px;
            img {
              width: 100%;
              vertical-align: middle;
            }
          }
          .one-text {
            flex: 1;
            text-align: center;
            margin-right: 4px;
          }
          .one-img3 {
            width: 20px;
            img {
              width: 100%;
              vertical-align: middle;
            }
          }
        }
        .one-cont-right {
          justify-content: space-between;
          .cont-right-text {
            flex: 1;
            text-align: center;
          }
        }
        .one-img2 {
          flex: 0.4;
          img {
            width: 60px;
          }
        }
      }
      .no-border-why {
        border: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/common/book-keeping.vue